import { ActiveOrganizationAvatar } from "@components/avatar/ActiveOrganizationAvatar";
import { OrganizationViewNavigationDropdownBody } from "@components/organizationView/OrganizationViewNavigationDropdownBody";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { SideNavMenuPicker } from "./SideNavMenuPicker";

/** The org switcher and firm settings: today's org menu behind the side nav's trigger. */
export const OrgSideNavPicker = () => {
    const activeOrganization = useActiveOrganization();

    return (
        <SideNavMenuPicker
            avatar={<ActiveOrganizationAvatar size="sm" aria-hidden />}
            label={activeOrganization?.name ?? ""}
        >
            <OrganizationViewNavigationDropdownBody />
        </SideNavMenuPicker>
    );
};
